// Deep equal good enough for comparing redux actions
const simpleDeepEqual = (a, b) => {
   if (a === b) {
      return true;
   }
   if (
      typeof a === 'object' &&
      a != null &&
      typeof b === 'object' &&
      b != null
   ) {
      const aEntries = Object.entries(a);
      if (aEntries.length !== Object.keys(b).length) return false;

      return aEntries.reduce(
         (isMatch, [aKey, aValue]) =>
            isMatch && simpleDeepEqual(aValue, b[aKey]),

         true
      );
   }
   return false;
};

export { simpleDeepEqual };
